import { onBeforeUnmount } from 'vue';
import { useLocalStorage } from '@vueuse/core';

/**
 * Width state for a floating panel that hugs the inline-end edge and is
 * resized by dragging its inline-start edge towards the centre - leftwards in
 * LTR, rightwards in RTL. The width is remembered in localStorage.
 */
export function useCsmlResizable(storageKey, { min, max, initial }) {
  const width = useLocalStorage(storageKey, initial);
  let origin = null;

  const onMove = event => {
    if (!origin) return;
    const delta = (event.clientX - origin.x) * origin.direction;
    width.value = Math.min(max, Math.max(min, origin.width - delta));
  };

  const stop = () => {
    origin = null;
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('mouseup', stop);
  };

  const startResize = event => {
    event.preventDefault();
    origin = {
      x: event.clientX,
      width: width.value,
      direction: document.dir === 'rtl' ? -1 : 1,
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', stop);
  };

  onBeforeUnmount(stop);

  return { width, startResize };
}
